
import * as actions_service_requests from 'actions/service-requests-actions';
import * as toolbox from 'components/common/toolbox';
import React, { useState } from 'react';
import _ from 'lodash';
import { APPS, REQUESTS } from 'components/constants';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import { Ibox } from 'enspire-manager-framework';
import { PERMISSIONS, SERVICE_REQUEST_TERMS } from 'components/constants';
import { Table } from 'em-table';
import { numPanels } from 'components/common/toolbox';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ServiceRequestsTab = (props) => {
    
    /* Hooks --------------------------*/
    
    const seg = 5;
    const params = useParams();

    const assets = useSelector((store) => store.assets);
    const serviceRequests = useSelector((store) => store.serviceRequests.service_requests);
    const settings = useSelector((store) => store.settings);
    const user = useSelector(store => store.users?.user);
    const user_permissions = useSelector(store => store.users?.user_permissions);
   
    const isAsset = (params.appId == APPS.ASSETS.id);
    const asset = assets.assets.find((asset) => asset.id == params.asset_id);

    const isCustomerAssigned = (isAsset) ? (asset?.customerId === user?.profileId) : false;
    const isServiceRequest = (props.source == 'service_requests');
    const filteredRequests = (isAsset) ? serviceRequests.filter((request) => request.assetId == params.asset_id) : serviceRequests;
    const requests = (isServiceRequest) 
        ? filteredRequests.filter((request) => parseInt(request.statusId) < REQUESTS.COMPLETE.id) 
        : filteredRequests.filter((request) => parseInt(request.statusId) >= REQUESTS.COMPLETE.id);

    // Permissions ----------------------------------------

    const openServiceForm = (type) => {
        let location = toolbox.modifyPath(props.location.pathname, seg, (type == 'record') ? `record-form` : `request-form`, 13);
        props.history.push({ pathname: location });
    }

    /* Actions ----------------------------*/

    const openServiceRequest = async (serviceRequest) => {
        const workOrderIds = await actions_service_requests.getWorkOrderIdsByServiceRequestId(params.handle, serviceRequest.id);

        if (serviceRequest.serviceRequestTermsId == SERVICE_REQUEST_TERMS.SERVICE_CALL.id) {
            toolbox.listLink(props.history, props.location.pathname, seg+3, `${serviceRequest.id}/work_orders/${workOrderIds?.[0]}/items`, null, seg+6);
        } else {
            if (serviceRequest.serviceRequestTermsId == SERVICE_REQUEST_TERMS.PROJECT_QUOTE.id) {
                toolbox.listLink(props.history, props.location.pathname, seg+3, `${serviceRequest.id}/quotes`, null, seg+4);
            } else {
                toolbox.listLink(props.history, props.location.pathname, seg+3, `${serviceRequest.id}/work_orders`, null, seg+4);
            }
        }
    }

    /* Constants --------------------------*/
    
    const data = requests.map((request) => {
        // Permissions ----------------------------------------
        let isTeamSR = (request?.techIds?.includes(user?.profileId) || request?.techIds?.includes(user?.email));
        request._no_click = (!user_permissions[PERMISSIONS.SERVICE_REQUESTS_VIEW.key] && !isTeamSR);

        Object.keys(REQUESTS).forEach((level) => {
            if (REQUESTS[level].id == request.statusId) request._stripe_color = REQUESTS[level].color;
        });
        return request;
    }); 

    const redistWidth = 50;
    const redist = (num) => (numPanels() > 1) ? num : num + (num / (100 - redistWidth) * (redistWidth));
    const columns = [
        { name: "Id", field: "customId", nowrap: true, width: redist(10) },
        ...(isServiceRequest) 
            ? [{ name: "Date Requested", field: "created", type: "date", format: 'MMM Do, YYYY', width: redist(25) }]
            : [{ name: "Date Completed", field: "completedDate", type: "date", format: 'MMM Do, YYYY', width: redist(25) }],
        { name: "Description", field: "description", ...(!numPanels(1)) ? { width: 50 } : {} },
        { name: "Total Cost", field: "totalCost", type: 'number', format: 'usd', text_align: 'right', width: redist(15) },
    ];

    const serviceButton = (user_permissions[PERMISSIONS.SERVICE_REQUESTS_CREATE.key])
        ?   <DropdownButton 
                title="+ Service &nbsp;" 
                variant="primary" size="sm" className="d-inline mr-2 mb-2 pull-right"
                onClick={(event) => { if (event?.stopPropagation) event?.stopPropagation(); }}
                disabled={ (!user_permissions[PERMISSIONS.SERVICE_REQUESTS_CREATE.key]) }
            >
                <Dropdown.Item eventKey="2" onClick={openServiceForm.bind(this, 'request')}>Service Request</Dropdown.Item>
                { isAsset &&
                    <Dropdown.Item eventKey="1" onClick={openServiceForm.bind(this, 'record')}>Completed Service Record</Dropdown.Item>
                }
                {/* <Dropdown.Item eventKey="3" onClick={()=>{ alert('Coming Soon!') }}>Recurring Maintenance</Dropdown.Item> */}
            </DropdownButton>
        : null;

    return (
        <Ibox title={(isServiceRequest) ? 'Open Service Requests' : 'Service History'} jsx={serviceButton}>
            {/* <h3>{(isServiceRequest) ? 'Open Service Requests' : 'Service History'}</h3> */}
            <Table id="service-request-tab"
                active_field={'id'}
                active_id={params.tab_id}
                chevron={true}
                click_callback={(request) => openServiceRequest(request) }
                columns={columns}
                data={data}
                highlight_search={true}
                second_line={(numPanels(1)) ? 'description' : ''}
                second_line_prefix={<i className="fa-solid fa-circle-arrow-right fa-lg mr-1"></i>}
                show_search={true}
            />
        </Ibox>
    );
};

export default ServiceRequestsTab;